import('./bootstrap')
  .catch(err => console.error('Error al iniciar la aplicación:', err));
